'use strict';

// M156 page configuration for the shared pergola configurator engine.
window.PERGOLA_CONFIG = {
  product: 'M156 Minimalist Manual Pergola',
  options: {
    install_type: [
      { value: 'Freestanding', svg: 'freestanding' },
      { value: 'Wall-mounted', svg: 'wall' },
      { value: 'Corner wall-mounted', svg: 'corner' },
      { value: 'Not sure', svg: 'unsure' }
    ],
    size_standard: [
      { value: '3 × 3 m', note: '9 m² · manual drive' },
      { value: '3 × 4 m', note: '12 m² · manual drive' },
      { value: '3 × 5 m', note: '15 m² · manual drive' }
    ],
    frame_colour: [
      { value: 'Sand-textured grey', frame: 'ls-frame-sand-grey' },
      { value: 'Sand-textured coffee', frame: 'ls-frame-sand-coffee' },
      { value: 'White', frame: 'ls-frame-white' },
      { value: 'Metallic grey', frame: 'ls-frame-metallic' },
      { value: 'Wood-look · premium', label: 'Wood-look', note: 'Premium finish', frame: 'ls-frame-wood' },
      { value: 'Help me choose', label: 'Help me choose', frame: 'ls-frame-help' }
    ],
    trough_light: [
      { value: 'Yes — add trough ambient light', label: 'Add trough light', note: 'Soft glow along the gutter line' },
      { value: 'No trough light', label: 'No thanks', note: 'Blade lighting is not available on M156' },
      { value: 'Please advise', label: 'Please advise', note: 'We’ll recommend based on your layout' }
    ]
  },
  sync(get, api) {},
  invalid(step, get, $) {
    const need = (name, message) => !get(name) ? { message, target: document.querySelector(`[name="${name}"]`) } : null;
    if (step === 0) return need('install_type', 'Choose where the pergola will be installed, or select Not sure.') || need('exposure', 'Choose an installation environment, or select Not sure.');
    if (step === 1) {
      const missing = need('size_standard', 'Choose one of the three standard sizes.');
      if (missing) return missing;
      const sets = Number(get('identical_sets'));
      if (!Number.isInteger(sets) || sets < 1 || sets > 99) return { message: 'Enter 1 to 99 identical units.', target: $('#identical_sets') };
    }
    if (step === 2) return need('frame_colour', 'Choose a frame finish, or select Help me choose.');
    if (step === 3) return need('trough_light', 'Choose a trough ambient light option.');
    return null;
  },
  summary(get) {
    const rows = [
      ['Installation', [get('install_type'), get('exposure')].filter(Boolean).join(' · ')],
      ['Size', get('size_standard') || 'Standard size to be selected'],
      ['Frame finish', get('frame_colour')],
      ['Operation', 'Manual drive'],
      ['Trough light', get('trough_light')]
    ];
    if (get('led_control_interest')) rows.push(['LED control system', get('led_control_interest')]);
    if (get('custom_finish_request')) rows.push(['Special finish', get('custom_finish_request')]);
    rows.push(['Identical units', get('identical_sets') || '—']);
    return rows;
  },
  example(set) {
    const example = {
      install_type: 'Wall-mounted', exposure: 'Balcony / high-rise terrace',
      size_standard: '3 × 4 m', frame_colour: 'Metallic grey',
      trough_light: 'Yes — add trough ambient light', led_control_interest: 'Yes'
    };
    Object.entries(example).forEach(([name, value]) => set(name, value));
  }
};
